
import { Options, Vue } from 'vue-class-component';
import * as OM from '@/model';
import { InAppNotificationClient } from '@/services/Services';
import store from '@/store';
import { Prop } from 'vue-property-decorator';

@Options({})
export default class villageTripBookAnswer extends Vue {

    @Prop() item: OM.VillageTripBookAnswer;

    onClick(){
        this.$router.push('/village/escursioni/' + this.item.villageTrip.identifier)
        .then(x => {
            this.$emit('clicked');
        });
    }

}
